import { Footer } from "antd/es/layout/layout"
import React from "react"

function FooterLayout(props:any){
  return (
    <Footer style={{ textAlign: "center" }}>Copyright © RiByte 2025</Footer>
  )
}

export default FooterLayout